<template>
<!--
  <div style="box-shadow:0px 0px 10px #eee;background:white;">
    <div class="left-title"><img src="/static/images/product/search.svg" style="margin-right:10px"/>Product Category</div>

    <div class="left-panel" style="border-top:1px solid #e2e6eb;">
        <div>
            <div class="panel-title" @click="jump('1')">
                <span>Aluminium Hydroxide</span><span style="float:right">&gt;</span>
            </div>
        </div>
    </div>

    <div class="left-panel panel panel-default">
        <div class="panel-heading" role="tab" id="heading3">
            <div class="panel-title" @click="jump('3')"> 
                    <span>PVC Additives</span><span style="float:right">&gt;</span>
            </div>
        </div>
    </div>

	<div class="left-panel">
        <div>
            <div class="panel-title" @click="jump('2')">
                <span>Boron Nitride</span>
                <span style="float:right;font-weight:bold" >&gt;</span>
            </div>
        </div>
    </div>

    

    <div class="left-panel panel panel-default">
        <div class="panel-heading" role="tab" id="heading7">
            <div class="panel-title" @click="jump('4')">
                <span>Raw materials</span><span style="float:right">&gt;</span>
            </div>
        </div>
       
    </div>
    
    <div class="left-panel panel panel-default">
        <div class="panel-heading" role="tab" id="heading6">
            <div class="panel-title"  @click="jump('5')">
                <span>Food Additives</span><span style="float:right">&gt;</span>
            </div>
        </div>
    </div>
    
</div>-->

<div class="left">
    <div class="left-title1">{{$t('menu_product_left')}}</div>

    <div class="left-panel1" style="border-top:1px solid #e2e6eb;">
        <div>
            <div class="panel-title" @click="jump('1')">
                <span>{{$t('menu_product_1')}}</span>
            </div>
        </div>
    </div>

    <div class="left-panel1">
        <div>
            <div class="panel-title" @click="jump('2')">
                <span>{{$t('menu_product_2')}}</span>
                
            </div>
        </div>
    </div>

    <div class="left-panel1 panel panel-default">
        <div class="panel-heading" role="tab" id="heading3">
            <div class="panel-title" @click="jump('3')"> 
                    <span>{{$t('menu_product_3')}}</span>
            </div>
        </div>
    </div>

	

    

    <div class="left-panel1 panel panel-default">
        <div class="panel-heading" role="tab" id="heading7">
            <div class="panel-title" @click="jump('4')">
                <span>{{$t('menu_product_4')}}</span>
            </div>
        </div>
       
    </div>
    
    <!-- <div class="left-panel1 panel panel-default">
        <div class="panel-heading" role="tab" id="heading6">
            <div class="panel-title"  @click="jump('5')">
                <span>Food Additives</span>
            </div>
        </div>
    </div> -->


    <div style="margin-top:30px;background:#e1e1e1;padding-left:15px;height:50px;line-height:50px;">
        <div class="panel-heading" role="tab" id="heading6">
            <div class="panel-title" style="font-weight:bold;font-size:18px;">
                <span>{{$t('left_q_title')}}</span>
            </div>
        </div>
    </div>

    <div style="background:#f1f1f1;padding:0px 15px">
        <div class="sub-panel1" @click="jump1()">{{$t('left_q_1')}}</div>
        <div class="sub-panel1" @click="jump1()">{{$t('left_q_2')}}</div>
        <div class="sub-panel1" @click="jump1()">{{$t('left_q_3')}}</div>
        <div class="sub-panel1" @click="jump1()">{{$t('left_q_4')}}</div>
        <div class="sub-panel1" style="border:none" @click="jump1()">{{$t('left_q_5')}}</div>
    </div>
</div>
</template>

<script>
import bus from '../util/bus';
export default {
    created(){
    
    },
    mounted(){
        
    },
    components: {
       
    },
    methods:{
        jump1(){
            $(window).scrollTop(0);
            this.$router.push('service');
        },
        jump(url){
            
            this.$router.push('category?id='+url);
            
            bus.$emit('changecategory');
        }
    }
};
</script>

<style>
.left-title{
    font-size:18px;
    font-weight:bold;
    height:50px;
    line-height:50px;
    padding-left:20px;
    
}

.left-title1{
    font-size:18px;
    font-weight:bold;
    height:70px;
    line-height:70px;
    padding-left:20px;
    background:#526193;
    color:white;
}

.left-panel{
    overflow:hidden;
    height:40px;
    padding-left:20px;
    padding-right:20px;
    line-height:40px;
    color:#526193;
    font-size:13px;
    border-bottom:1px solid #e2e6eb;
}

.sub-panel1{
    height:40px;
    line-height:40px;
    font-size:13px;
   
    color:#333;
    border-bottom:1px solid #fff;
}

.sub-panel1:hover{
    padding-left:20px;
    cursor:pointer;
    color:#333;
    transition:0.3s;
}

.left-panel1{
    overflow:hidden;
    height:50px;
    padding-left:20px;
    padding-right:20px;
    line-height:50px;
    color:#333;
    background:#e1e1e1;
    font-size:15px;
    border-bottom:1px solid white;
}

.left-panel1:hover{
    background:#526193;
    color:white;
    cursor:pointer;
}

.left-panel:hover{
    background:#3880e51a;
    cursor:pointer;
}

@media (max-width:520px){
    .left{
        display:none;
    }
}
</style>



// WEBPACK FOOTER //
// left.vue?601db7c1